<ng-template #contentTemplate>
  <ng-content></ng-content>
</ng-template>

<span
  *ngIf="template"
  [ngbPopover]="template"
  #popover="ngbPopover"
  triggers="manual"
  [placement]="getPopoverPlacement | thunk : content.header"
  class="popover-cell"
  (click)="onCellClick(popover)">
  <ng-container [ngTemplateOutlet]="contentTemplate"></ng-container>
</span>

<ng-container
  *ngIf="!template"
  [ngTemplateOutlet]="contentTemplate">
</ng-container>
